export default "__VITE_ASSET__Bwgj2Nyz__"